var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('feather-icon',{attrs:{"title":"Edit","icon":"EditIcon","svgClasses":"h-6 w-6 hover:text-primary cursor-pointer"},on:{"click":function($event){return _vm.editGamePopup()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }